import { z } from "zod";
import { getIdSchema, ID, makeIdGenerator } from "../utils";
import { accountIdSchema } from "./accountSchema";

export const loadIdPrefix = "loa_";
export type LoadId = ID<typeof loadIdPrefix>;
export const generateLoadId = makeIdGenerator(loadIdPrefix);
export const loadIdSchema = getIdSchema(loadIdPrefix, "LoadId");

export const loadSchema = z
  .object({
    id: loadIdSchema,
    accountId: accountIdSchema,
    name: z.string(),
    isScout: z.boolean().default(false),
    retiredAt: z.coerce.date().nullable(),
    location: z
      .object({
        name: z.string(),
        since: z.coerce.date(),
      })
      .optional(),
  })
  .meta({ id: "Load" });

export const otaLoadSchema = loadSchema
  .omit({ location: true })
  .meta({ id: "OtaLoad" });

export type Load = z.infer<typeof loadSchema>;

export const putLoadSchema = z
  .object({
    name: z.string().min(1),
    retiredAt: z.coerce.date().nullable(),
    isScout: z.boolean().optional(),
  })
  .meta({ id: "LoadUpdate" });

export type PutLoad = z.infer<typeof putLoadSchema>;
